<div class="header-bar">
  <h1>Engineius Order Cancellation Report</h1>
</div>
<div class="">
  <div class="">
    <div class="content-container">
      <div class="">
        <form (ngSubmit)="search()" style="width: 100%">
          <div class="ui-g filterPanel">
            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <p-calendar
                  [(ngModel)]="filterVal.filters.createDateFrom.value"
                  name="createDateFrom"
                  dateFormat="dd/mm/yy"
                ></p-calendar>
                <label>Date Create From</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <p-calendar
                  [(ngModel)]="filterVal.filters.createDateTo.value"
                  name="createDateTo"
                  dateFormat="dd/mm/yy"
                ></p-calendar>
                <label>Date Create To</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <p-calendar
                  [(ngModel)]="filterVal.filters.cancelDateFrom.value"
                  name="canceleDateFrom"
                  dateFormat="dd/mm/yy"
                ></p-calendar>
                <label>Cancelled Date From</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <p-calendar
                  [(ngModel)]="filterVal.filters.cancelDateTo.value"
                  name="canceleDateTo"
                  dateFormat="dd/mm/yy"
                ></p-calendar>
                <label>Cancelled Date To</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <input
                  pInputText
                  name="orderRef"
                  type="text"
                  style="width: 100%"
                  [(ngModel)]="filterVal.filters.orderRef.value"
                />
                <label>Order Ref</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-4">
              <div class="ui-g-3">
                <label>Customer</label>
              </div>
              <div class="ui-g-9">
                <p-dropdown
                  [options]="customers"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  [(ngModel)]="filterVal.filters.customer.value"
                  name="customers"
                ></p-dropdown>
              </div>
            </div>

            <div class="ui-g-12">
              <button
                pButton
                type="button"
                label="Clear"
                class="ui-button btn-to-right"
                (click)="clearFilter(dt)"
              ></button>
              <button pButton type="submit" label="Search" class="ui-button btn-to-right"></button>
            </div>
          </div>
        </form>
        <h2 class="sub-header-bar">Summary</h2>

        <p-table
          [value]="pageSummary.items"
          [responsive]="true"
          [lazy]="true"
          [paginator]="true"
          rowHover="true"
          resizableColumns="true"
          [totalRecords]="pageSummary.total"
          [hidden]="!isLoadedSummary"
          (onLazyLoad)="onGridSummaryLazyLoad($event)"
          [rowsPerPageOptions]="[5, 10, 20]"
          [pageLinks]="3"
          [rows]="10"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Period Filter (Day,Month,Year)</th>
              <th>Customer Name</th>
              <th>Sum Total Orders Cancelled</th>
              <th>Average Days To Close</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item">
              <td>{{ item.period }}</td>
              <td>{{ item.customer }}</td>
              <td>{{ item.totalCancelled }}</td>
              <td>{{ item.avgDaysToClose }}</td>
            </tr>
          </ng-template>
        </p-table>

        <!-- DATATABLES DEPRECATED ---
        <p-dataTabl [value]="pageSummary.items" [responsive]="true" [lazy]="true" [paginator]="true"
                     rowHover="true" resizableColumns="true" [totalRecords]="pageSummary.total"
                     [hidden]="!isLoadedSummary" (onLazyLoad)="onGridSummaryLazyLoad($event)"
                     [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3" [rows]="10">
            <p-column field="period" header="Period Filter (Day,Month, Year)"></p-column>
            <p-column field="customer" header="Customer Name"></p-column>
            <p-column field="totalCancelled" header="Sum Total Orders Cancelled"></p-column>
            <p-column field="avgDaysToClose" header="Average Days to Close"></p-column>
        </p-dataTable>
        --->

        <h2 class="sub-header-bar">Detail</h2>

        <p-table
          #dt
          [value]="page.items"
          [lazy]="true"
          [rows]="10"
          [responsive]="true"
          [paginator]="true"
          rowHover="true"
          resizableColumns="true"
          [totalRecords]="page.total"
          (onLazyLoad)="onGridLazyLoad($event)"
          [hidden]="!isLoaded"
          [rowsPerPageOptions]="[5, 10, 20]"
          [pageLinks]="3"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="orderRef">Order Ref</th>
              <th pSortableColumn="customer">Customer Name</th>
              <th pSortableColumn="supplier">Supplier Name</th>
              <th pSortableColumn="movementType">Movement Type</th>
              <th pSortableColumn="dateCreated">Date Created</th>
              <th pSortableColumn="pickupLatest">Pickup Latest</th>
              <th pSortableColumn="minAmount">Min Amount</th>
              <th pSortableColumn="maxAmount">Max Amount</th>
              <th pSortableColumn="amount">Final</th>
              <th pSortableColumn="dateCancelled">Date Cancelled</th>
              <th pSortableColumn="cancellationStatus">Cancellation Status</th>
              <th pSortableColumn="cancellationDescription">Cancellation Reason</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item">
              <td>{{ item.orderRef }}</td>
              <td>{{ item.customer }}</td>
              <td>{{ item.supplier }}</td>
              <td>{{ item.movementType }}</td>
              <td>
                <span>{{ item.dateCreated | date : 'dd/MM/yyyy' }}</span>
              </td>
              <td>
                <span>{{ item.pickupLatest | date : 'dd/MM/yyyy' }}</span>
              </td>
              <td>
                <span>{{ item.minAmount | currency : 'GBP' : 'symbol' : '1.2-2' }}</span>
              </td>
              <td>
                <span>{{ item.maxAmount | currency : 'GBP' : 'symbol' : '1.2-2' }}</span>
              </td>
              <td>
                <span>{{ item.amount | currency : 'GBP' : 'symbol' : '1.2-2' }}</span>
              </td>
              <td>
                <span>{{ item.dateCancelled | date : 'dd/MM/yyyy' }}</span>
              </td>
              <td>
                <div title="{{ item.cancellationStatus }}">
                  {{ item.cancellationStatus }}
                </div>
              </td>
              <td>
                <div title="{{ item.cancellationDescription }}">
                  {{ item.cancellationDescription }}
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!-- DATATABLES DEPRECATED --
        <p-dataTabl #dt [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true"
                     rowHover="true" resizableColumns="true"
                     [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)"
                     [hidden]="!isLoaded" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3">
          <p-column field="orderRef" header="Order Ref" [sortable]="tru"></p-column>
          <p-column field="customer" header="Customer Name" [sortable]="tru"></p-column>
          <p-column field="supplier" header="Supplier Name" [sortable]="tru"></p-column>
          <p-column field="movementType" header="Movement Type" [sortable]="tru"></p-column>
          <p-column field="dateCreated" header="Date Created" [sortable]="tru">
            <ng-template let-col let-order="rowData" pTemplate="body">
              <span>{{ order[col.field] | date:'dd/MM/yyyy' }}</span>
            </ng-template>
          </p-column>
          <p-column field="pickupLatest" header="Pickup Latest" [sortable]="tru">
            <ng-template let-col let-order="rowData" pTemplate="body">
              <span>{{ order[col.field] | date:'dd/MM/yyyy' }}</span>
            </ng-template>
          </p-column>
          <p-column field="minAmount" header="Min Amount" [sortable]="tru">
            <ng-template let-order="rowData" pTemplate="body">
              <span>{{ order.minAmount | currency:'GBP':'symbol':'1.2-2' }}</span>
            </ng-template>
          </p-column>
          <p-column field="maxAmount" header="Max Amount" [sortable]="tru">
            <ng-template let-order="rowData" pTemplate="body">
              <span>{{ order.maxAmount | currency:'GBP':'symbol':'1.2-2' }}</span>
            </ng-template>
          </p-column>
          <p-column field="amount" header="Final" [sortable]="tru">
            <ng-template let-order="rowData" pTemplate="body">
              <span>{{ order.amount | currency:'GBP':'symbol':'1.2-2' }}</span>
            </ng-template>
          </p-column>
          <p-column field="dateCancelled" header="Date Cancelled" [sortable]="tru">
            <ng-template let-col let-order="rowData" pTemplate="body">
              <span>{{ order[col.field] | date:'dd/MM/yyyy' }}</span>
            </ng-template>
          </p-column>
          <p-column field="cancellationStatus" header="Cancellation Status" [sortable]="tru">
            <ng-template let-item="rowData" pTemplate="body">
              <div title="{{item.cancellationStatus}}">
                {{item.cancellationStatus}}
              </div>
            </ng-template>
          </p-column>
          <p-column field="cancellationDescription" header="Cancellation Reason" [sortable]="tru">
            <ng-template let-item="rowData" pTemplate="body">
              <div title="{{item.cancellationDescription}}">
                {{item.cancellationDescription}}
              </div>
            </ng-template>
          </p-column>
        </p-dataTable>
        --->
      </div>
      <div class="ui-g-12" style="height: 40px; margin-top: 20px">
        <button
          type="button"
          pButton
          icon="fa ui-icon-file-download"
          label="Download"
          class="ui-button btn-to-right"
          (click)="downloadReport()"
          [disabled]="page.total == 0"
        ></button>
      </div>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
